import { useAuth } from "@/hooks/useAuth"

// ---------------------------------------------------------------------------
// useHrAdminGate — client-side UI visibility gate for HR-admin-only content
// (Leave Rules page, bijzonder verlof / special-leave picker). Separate from
// useOwnerGate (Artem-only, gates €-sections in Reports) — HR admin covers
// Artem + Antonella. RLS still governs the underlying data; this only
// controls what renders.
// ---------------------------------------------------------------------------

const HR_ADMIN_EMAILS = ["artem@teddykids.nl", "antonella@teddykids.nl"]

export function useHrAdminGate(): { isHrAdmin: boolean; isLoading: boolean } {
  const { user, loading } = useAuth()
  return { isHrAdmin: HR_ADMIN_EMAILS.includes(user?.email ?? ""), isLoading: loading }
}
